import Request from './request';

async function fetch(data) {
    return Request('get', "api/print-templates", data);
}

async function fetchOne(code, noResponseError) {
    return Request('get', "api/print-templates/0", { print_template_code: code }, false, noResponseError);
}

async function fetchTemplate(data, noResponseError) {
    return Request('get', "api/print-templates/0", data, false, noResponseError);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id)
        return Request('patch', "api/print-templates/edit?id=" + id, data);
    else
        return Request('post', "api/print-templates/add", data);
}

async function del(id) {// 删除数据
    return Request('get', "api/print-templates/delete/" + id);
}

export default {
    fetch,
    fetchOne,
    fetchTemplate,
    save,
    del,
};